<script>
  import { fade } from "svelte/transition";
  import Redirect from "../../components/backDashboard.svelte";
  import { user } from "../../firebase";
  import PhotoUpload from "./PhotoUpload.svelte";
  import { onMount } from "svelte";
  import { Utils } from "../../utils";
  import { conversion, lang } from "../../store/store";
  import {
    EmailAuthProvider,
    updatePassword,
    reauthenticateWithCredential,
  } from "firebase/auth";
  import { auth } from "../../firebase";
  import MaterialSpinner from "../../components/MaterialSpinner.svelte";

  let loading = false;
  let load = false;
  let NotificationSetting = [
    {
      name:
        $conversion[$lang].accountSettings.notification.options.option1.title,
      desc:
        $conversion[$lang].accountSettings.notification.options.option1
          .subtitle,
      email: false,
      push: false,
    },
    {
      name:
        $conversion[$lang].accountSettings.notification.options.option2.title,
      desc:
        $conversion[$lang].accountSettings.notification.options.option2
          .subtitle,
      email: false,
      push: false,
    },
    {
      name:
        $conversion[$lang].accountSettings.notification.options.option2.title,
      desc:
        $conversion[$lang].accountSettings.notification.options.option2
          .subtitle,
      email: false,
      push: false,
    },
  ];
  let temp;
  const { doc } = $user;
  console.log($doc);
  let userinfo = { account: {} };
  let backupInfo = { account: {} };
  onMount(() => {
    if (!$doc.account) {
      userinfo = {
        account: {
          img:
            "https://firebasestorage.googleapis.com/v0/b/expertify-tasks-dev.appspot.com/o/assets%2Fuser.png?alt=media&token=c7eff643-3c19-47a0-8ddf-0150f58de8f8",
          firstname: "John|Jane",
          lastname: "Doe",
          shop: "Expertify",
          email: "Doe@gmail.com",
          phone: "+212 6 94282596",
          locale: "en",
          afterhours: false,
          notifications: NotificationSetting,
        },
      };
    } else {
      userinfo = $doc;
      if (!userinfo.notifications) {
        //in case we won't create the notification object in the INIT
        userinfo.notifications = NotificationSetting;
      }
      if (!userinfo.afterhours) {
        //in case we won't create the after hours checkbox parameter in the INIT
        userinfo.afterhours = false;
      }
    }
    backupInfo = JSON.parse(JSON.stringify(userinfo));
  });

  let title = $conversion[$lang].accountSettings.backToDashBoardTitle;

  let firstname;
  let lastname;
  let email;
  let phone;
  let oldpwd = "";
  let newpwd = "";
  let confirmpwd = "";
  let pwdstatus = "";

  let menuCond = false;
  let menu = [
    {
      name: "en",
      languague: "English",
    },
    {
      name: "fr",
      languague: "French",
    },
  ];

  $: {
    if (!!document.getElementById("menu")) {
      if (menuCond) {
        document.getElementById("menu").style.display = "flex";
      } else {
        document.getElementById("menu").style.display = "none";
      }
    }
  }

  let validate;
  function checkpwds() {
    if (newpwd.length > 7) {
      if (newpwd == confirmpwd) {
        pwdstatus = "right";
      } else {
        pwdstatus = "wrong";
      }
    }
  }
  let test = {
    firstname: false,
    lastname: false,
    phone: false,
    email: false,
  };
  let photo;

  function testpwd() {
    if (newpwd.length > 7) {
      validate = true;
      errors.password.password = false;
    } else {
      errors.password.password = true;
      errors.password.message =
        $conversion[$lang].accountSettings.errors.shortPassword;
    }
  }
  function handleAttachment(event) {
    loading = true;
    photo = event.target.files[0];
    userinfo.account.img = URL.createObjectURL(photo);
    return;
  }

  const verify = async () => {
    test.firstname = /^[a-zA-Z]{3,16}/g.test(
      String(userinfo.account.firstname)
    );
    test.lastname = /^[a-zA-Z]{3,16}/g.test(String(userinfo.account.lastname));
    test.phone = /^[0-9]{2}\s{0,1}[0-9]{3}\s{0,1}[0-9]{3}$/g.test(
      userinfo.account.phone
    );
    const expression = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
    test.email = expression.test(String(userinfo.account.email));
    if (!test.firstname) {
      userinfo.account.firstname = backupInfo.account.firstname;
      test.firstname = !test.firstname;
    }
    if (!test.lastname) {
      userinfo.account.lastname = backupInfo.account.lastname;
      test.lastname = !test.lastname;
    }
    if (!test.phone) {
      userinfo.account.phone = backupInfo.account.phone;
      test.phone = !test.phone;
    }
    if (!test.email) {
      userinfo.account.email = backupInfo.account.email;
      test.email = !test.email;
    }

    if (test.firstname && test.lastname && test.phone && test.email) {
      $lang = userinfo.account.locale;
      await $user.update.profile(userinfo);
      if (userinfo?.account?.img) {
        $doc.account.img = userinfo.account.img;
      }

      console.log("done?");
    }
  };

  const HandleNotifications = async () => {
    await $user.update.profile(userinfo.notifications);
  };

  function callbackFunction(event) {
    userinfo.account.img = Utils.file.tokenToLink(
      `stores/${$user.auth.claims.store}/${event.detail.name}`,
      event.detail.token
    );
    loading = false;
  }

  let errors = {
    password: {
      password: false,
      message: "",
    },
  };

  let updated = false;
  let wrongpassword = $conversion[$lang].accountSettings.errors.wrongPassword;
  function changepwd() {
    load = true;
    console.log("started to change pwd");
    errors.password.password = false;
    const user = auth.currentUser;
    const credential = EmailAuthProvider.credential(
      userinfo.account.email,
      oldpwd
    );
    reauthenticateWithCredential(user, credential)
      .then(() => {
        updatePassword(user, newpwd).then(() => {
          console.log("Updated.");
          updated = true;
          load = false;
        });
      })
      .catch((error) => {
        console.log(error);
        console.log("Old password is wrong.");
        errors.password.password = true;
        errors.password.message =
          $conversion[$lang].accountSettings.errors.wrongPassword;
        load = false;
      });
  }
</script>

<style>
  .contentWrapper {
    padding-bottom: 6rem;
    width: 95%;
    max-width: 1190px;
  }

  .title {
    font-size: 1.5em;
    color: #0a1629;
    margin-top: 1rem;
    margin-bottom: 1.5rem;
    font-weight: 500;
  }

  .error-container {
    color: #e6107b;
    margin-bottom: 0.6rem;
    font-size: 0.8em;
  }

  .approve-container {
    color: var(--primaryColor);
    margin-bottom: 0.6rem;
    font-size: 0.8em;
  }

  .general-ctn {
    display: flex;
    flex-direction: column;
    padding: 1rem 1rem 2rem 1rem;
    background-color: white;
    margin: 2rem 0 4rem 0;
    box-shadow: 0px 0px 1px rgba(12, 26, 75, 0.24),
      0px 3px 8px -1px rgba(50, 50, 71, 0.05);
    border-radius: 16px;
  }

  .user-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 3rem;
  }

  .input-attach-label {
    width: 100%;
    height: 100%;
    z-index: 5;
    cursor: pointer;
  }

  .u-plus {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .user-img {
    width: 3.5rem;
    height: 3.5rem;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 1rem;
    display: flex;
    position: relative;
    min-width: 56px;
  }
  .add-photo {
    width: 100%;
    height: 100%;
    position: absolute;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 1.9em;
    transition: all 0.8s ease;
    opacity: 0;
    cursor: pointer;
    z-index: 1;
  }
  .add-photo:hover {
    opacity: 1;
    transition: all 0.8s ease;
  }

  .column {
    display: flex;
    flex-direction: column;
  }

  .row {
    display: flex;
    flex-direction: row;
  }

  .user-name {
    font-size: 1em;
    font-weight: 500;
    margin-bottom: 0.1rem;
  }

  .shop-name {
    font-size: 0.9em;
    font-weight: 400;
  }

  .general-title {
    font-size: 1em;
    font-weight: 700;
    padding-left: 0.75rem;
    margin-bottom: 1.5rem;
  }

  .wrapper {
    width: 49%;
    display: flex;
    flex-direction: column;
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .input-title {
    font-size: 0.95em;
    font-weight: 500;
    margin-bottom: 0.5rem;
    color: #425466;
  }

  .inputfields {
    width: 100%;
    outline: none;
    border: 1px solid #d8e0f0;
    box-shadow: 0px 1px 2px rgba(184, 200, 224, 0.222055);
    border-radius: 6px;
    padding: 0.5rem 0.75rem;
    margin-bottom: 2rem;
  }

  .save-btn {
    padding: 0.7rem 1.2rem;
    background: var(--primaryColor);
    color: white;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: auto;
    border-radius: 6px;
    width: 100%;
    min-width: 17rem;
    max-width: max-content;
  }

  .password-txt {
    font-size: 1.325em;
    font-weight: 700;
    margin-bottom: 1.75rem;
  }

  .desc-txt {
    font-size: 0.9em;
    font-weight: 400;
    margin-bottom: 1.75rem;
    color: #425466;
  }

  .wrong {
    border: 1px solid #d2222d;
  }

  .right {
    border: 1px solid var(--primaryColor);
  }

  .dropdown-menu {
    position: relative;
    outline: none;
    border: 1px solid #d8e0f0;
    box-shadow: 0px 1px 2px rgba(184, 200, 224, 0.222055);
    border-radius: 6px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    padding: 0.5rem 0.75rem;
    font-size: 0.9em;
    color: #b5b5bd;
    cursor: pointer;
    width: 90%;
    background: white;
    margin-bottom: 1.5rem;
  }

  .arrow {
    position: absolute;
    top: 50%;
    right: 0px;
    transform: translate(-50%, -50%) rotate(90deg);
    padding: 0.1rem 0.5rem;
    border: 1px solid #d8e0f0;
    border-radius: 50%;
  }

  .dropdown-menu-rest {
    position: absolute;
    top: 105%;
    left: 0;
    width: 100%;
    background-color: white;
    display: none;
    flex-direction: column;
    border-bottom-right-radius: 14px;
    border-bottom-left-radius: 14px;
    box-shadow: 0px 1px 2px rgb(184 200 224 / 22%);
    border: 1px solid #d8e0f0;
    padding: 0.5rem 0;
    color: black;
    z-index: 500;
  }

  .option-ctn {
    display: flex;
    align-items: center;
    padding: 0.5rem 0.75rem;
    cursor: pointer;
  }

  .option-name {
    font-size: 0.9em;
    color: black;
    font-weight: 600;
  }
  .disabled {
    opacity: 0.5;
    transition: opacity 0.8s ease;
    cursor: initial;
  }

  .n-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin-bottom: 1.5rem;
  }

  .blank-space {
    width: 60%;
    padding: 1rem 2rem;
  }

  .notif-title {
    width: 17%;
    font-weight: 400;
    font-size: 0.8em;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .notif-ctn {
    padding: 1rem 2.5rem;
    background-color: #f4f9fd;
    border-radius: 14px;
    width: 60%;
    justify-content: center;
  }

  .n-title {
    color: #0a1629;
    font-size: 1em;
    font-weight: 700;
    margin-bottom: 0.7rem;
  }

  .n-desc {
    font-weight: 600;
    font-size: 0.875em;
    color: #7d8592;
  }

  .n-swipe-ctn {
    padding: 3rem 2rem;
    width: 17%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 14px;
    background-color: #f4f9fd;
  }

  .n-switch-ctn {
    width: 65px;
    border-radius: 18px;
    background-color: #ced5e0;
    display: flex;
    justify-content: flex-start;
    transition: all 0.8s ease;
    padding: 0.24rem;
    cursor: pointer;
  }

  .toggled {
    background-color: #3f8cff;
    transition: all 0.8s ease;
  }

  .n-switch-circle {
    height: 27.5px;
    width: 27.5px;
    border-radius: 50%;
    background-color: white;
    transition: all 0.8s ease;
  }

  .toggled .n-switch-circle {
    transform: translateX(29px);
    transition: all 0.8s ease;
  }

  .n-notif-time {
    align-items: center;
  }

  .checkmark {
    display: flex;
    justify-content: center;
    align-items: center;
    border: #0a1629 3px solid;
    padding: 0.15rem;
    border-radius: 6px;
    margin-right: 0.5rem;
    height: 25px;
    width: 25px;
    cursor: pointer;
  }

  .n-afterhours {
    font-size: 1em;
    font-weight: 400;
  }
  @media only screen and (max-width: 1100px) {
    .row {
      flex-direction: column;
    }
    .wrapper {
      width: 100%;
    }
    .dropdown-menu {
      width: 100%;
    }
  }
</style>

<div
  in:fade={{ duration: 300, delay: 300 }}
  out:fade={{ duration: 300, delay: 0 }}
  class="contentWrapper">
  <Redirect bind:title />
  <div class="title">{$conversion[$lang].accountSettings.generalTitle}</div>
  <div class="general-ctn">
    <div class="user-wrapper">
      <div class="user-img">
        <img src={userinfo.account.img} alt="" />
        <div class="add-photo">
          <div class="u-plus">+</div>
          <label class="input-attach-label" for="input">
            <input
              style="visibility:hidden"
              on:change={handleAttachment}
              id="input"
              class="attach"
              type="file"
              accept="image/png, image/gif, image/jpeg" />
          </label>
        </div>
        {#if photo != undefined}
          {#key photo}
            <PhotoUpload on:confirm={callbackFunction} file={photo} />
          {/key}
        {/if}
      </div>
      <div class="column">
        <div class="user-name">
          {userinfo.account.firstname}
          {userinfo.account.lastname}
        </div>
        <div class="shop-name">{userinfo.account.shopDomain}</div>
      </div>
    </div>

    <div class="general-title">
      {$conversion[$lang].accountSettings.accountInformations.generalTitle}
    </div>

    <div class="row">
      <div class="wrapper">
        <div class="input-title">
          {$conversion[$lang].accountSettings.accountInformations.labelFirstName}
        </div>
        <input
          on:blur={(userinfo.account.firstname = firstname)}
          bind:value={firstname}
          class="inputfields"
          placeholder={userinfo.account.firstname}
          type="text" />
      </div>
      <div class="wrapper">
        <div class="input-title">
          {$conversion[$lang].accountSettings.accountInformations.labelLastName}
        </div>
        <input
          on:blur={(userinfo.account.lastname = lastname)}
          bind:value={lastname}
          class="inputfields"
          placeholder={userinfo.account.lastname}
          type="text" />
      </div>
    </div>

    <div class="row">
      <div class="wrapper">
        <div class="input-title">
          {$conversion[$lang].accountSettings.accountInformations.labelEmail}
        </div>
        <input
          on:blur={(userinfo.account.email = email)}
          bind:value={email}
          class="inputfields"
          placeholder={userinfo.account.email}
          type="text" />
      </div>
      <div class="wrapper">
        <div class="input-title">
          {$conversion[$lang].accountSettings.accountInformations.labelPhoneNumber}
        </div>
        <input
          on:blur={(userinfo.account.phone = phone)}
          bind:value={phone}
          class="inputfields"
          placeholder={userinfo.account.phone}
          type="text" />
      </div>
    </div>

    <div class="row">
      <div class="wrapper">
        <div class="input-title">
          {$conversion[$lang].accountSettings.accountInformations.language}
        </div>
        <div
          on:click={() => {
            menuCond = !menuCond;
          }}
          class="dropdown-menu">
          <div class:on={menuCond} class="arrow">></div>
          <div class="color">{userinfo.account.locale}</div>
          <div id="menu" class="dropdown-menu-rest">
            {#each menu as option}
              <div
                on:click={() => {
                  userinfo.account.locale = option.name;
                }}
                class="option-ctn">
                <div class="option-name">{option.languague}</div>
              </div>
            {/each}
          </div>
        </div>
      </div>
    </div>

    <button
      on:click={verify}
      class:disabled={loading}
      disabled={loading}
      style="margin-right: 1rem;"
      class="save-btn">
      {$conversion[$lang].accountSettings.accountInformations.button}
    </button>
  </div>
  <!--  
    <div class="title">
        {$conversion[$lang].accountSettings.notification.generalTitle}
    </div>
    <div class="general-ctn">
        <div style="margin-bottom: 0.5rem;" class="n-wrapper">
            <div class="blank-space" />
            <div class="notif-title">
                {$conversion[$lang].accountSettings.notification.notifType.email}
            </div>
            <div class="notif-title">
                {$conversion[$lang].accountSettings.notification.notifType.push}
            </div>
        </div>
        {#if userinfo.notifications}
            {#each userinfo.notifications as option}
                <div class="n-wrapper">
                    <div class="column notif-ctn">
                        <div class="n-title">{option.name}</div>
                        <div class="n-desc">{option.desc}</div>
                    </div>

                    <div class="n-swipe-ctn">
                        <div
                            on:click={() => {
                                option.email = !option.email;
                            }}
                            class:toggled={option.email}
                            class="n-switch-ctn">
                            <div class="n-switch-circle" />
                        </div>
                    </div>

                    <div class="n-swipe-ctn">
                        <div
                            on:click={() => {
                                option.push = !option.push;
                            }}
                            class:toggled={option.push}
                            class="n-switch-ctn">
                            <div class="n-switch-circle" />
                        </div>
                    </div>
                </div>
            {/each}
        {/if}

        <div class="row n-notif-time">
            <div
                on:click={() => {
                    userinfo.afterhours = !userinfo.afterhours;
                }}
                class="checkmark">
                {#if userinfo.afterhours}
                    <svg
                        width="20"
                        height="20"
                        viewBox="0 0 14 9"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M13.3638 0.894017C13.7264 1.21132 13.7523 1.71168 13.4415 2.05514L13.3638 2.13145L6.29274 8.31864C5.93011 8.63594 5.35827 8.6586 4.96575 8.38663L4.87853 8.31864L0.635888 4.60633C0.245364 4.26462 0.245364 3.7106 0.635888 3.36889C0.998518 3.05159 1.57036 3.02893 1.96288 3.3009L2.0501 3.36889L5.58586 6.46173L11.9496 0.894017C12.3122 0.576716 12.8841 0.554052 13.2766 0.826025L13.3638 0.894017Z"
                            fill="#3F8CFF" />
                    </svg>
                {/if}
            </div>
            <div class="n-afterhours">
                {$conversion[$lang].accountSettings.notification.checkBox}
            </div>
        </div>

        <div on:click={verify} style="margin-right: 1rem;" class="save-btn">
            {$conversion[$lang].accountSettings.notification.button}
        </div>
    </div>
-->
  <div class="title">
    {$conversion[$lang].accountSettings.password.generalTitle}
  </div>
  <div style="padding: 1.75rem;" class="general-ctn">
    <!-- <div class="desc-txt">
      {$conversion[$lang].accountSettings.password.description}
    </div> -->

    <div class="input-title">
      {$conversion[$lang].accountSettings.password.currentPassword}
    </div>

    <input
      bind:value={oldpwd}
      class="inputfields"
      on:focus={() => {
        errors.password.message = '';
      }}
      class:wrong={errors.password.message == wrongpassword}
      placeholder="Current password"
      type="text" />

    <div class="input-title">
      {$conversion[$lang].accountSettings.password.newPassword}
    </div>

    <input
      on:blur={() => {
        testpwd();
        checkpwds();
      }}
      bind:value={newpwd}
      class:right={validate == true}
      class:wrong={validate == false}
      class="inputfields"
      placeholder="New password"
      type="text" />

    <div class="input-title">
      {$conversion[$lang].accountSettings.password.confirmPassword}
    </div>

    <input
      on:blur={() => {
        checkpwds();
        testpwd();
      }}
      bind:value={confirmpwd}
      class:right={pwdstatus == 'right'}
      class:wrong={pwdstatus == 'wrong'}
      class="inputfields"
      placeholder="Confirm password"
      type="text" />

    {#if errors.password.password}
      <div class="error-container">{errors.password.message}</div>
    {/if}

    {#if updated}
      <div class="approve-container">
        {$conversion[$lang].accountSettings.updated}
      </div>
    {/if}

    <div
      on:click={() => {
        changepwd();
      }}
      class="save-btn">
      {#if load}
        <MaterialSpinner height="25px" width="25px" />
      {:else}{$conversion[$lang].accountSettings.password.button}{/if}
    </div>
  </div>
</div>
